export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/7012d1ed0225cfc4bba0161dc27b2468/1c45ca435ac3f1865545cb6786551fc4.jpeg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Burtman's Painting & Landscape
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          Transform your Missouri property with expert painting & landscape services. Licensed, insured, and trusted by homeowners across Joplin since 2023.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
          <button 
            onClick={scrollToContact}
            className="px-10 py-4 bg-teal-600 text-white text-base font-semibold rounded-full hover:bg-teal-700 transition-all inline-flex items-center space-x-2 cursor-pointer whitespace-nowrap shadow-xl"
          >
            <span>Get Free Estimate</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <button 
            onClick={scrollToContact}
            className="px-10 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-full hover:bg-white/20 transition-all inline-flex items-center space-x-2 cursor-pointer whitespace-nowrap border-2 border-white/30"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>(417) 825-2408</span>
          </button>
        </div>

        <div className="mt-16 flex items-center justify-center space-x-12">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-1">200+</div>
            <div className="text-sm text-white/80">Satisfied Customers</div>
          </div>
          <div className="h-12 w-px bg-white/30"></div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-1">Est.</div>
            <div className="text-sm text-white/80">2023</div>
          </div>
          <div className="h-12 w-px bg-white/30"></div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-1">100%</div>
            <div className="text-sm text-white/80">Satisfaction</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/60"></i>
      </div>
    </section>
  );
}